// AI工具翻译

export const tools = {
    weddingPhoto: {
      title: '婚紗照',
      description: '支援中式/西式風格選擇，打造浪漫婚紗照',
      features: ['多圖上傳', '風格選擇', '可選提示詞'],
      ui: {
        uploadTitle: '上傳照片',
        uploadDescription: '最多支援 {max} 張，可預覽與移除',
        promptTitle: '補充提示詞（選填）',
        promptDescription: '可描述場景、服裝、氛圍與細節',
        promptPlaceholder: '例如：戶外儀式、柔和打光、優雅構圖',
        styleLabel: '婚紗風格',
        styles: {
          chinese: '中式婚紗',
          western: '西式婚紗'
        }
      }
    },
    emojiPack: {
      title: '表情包製作',
      description: '上傳一張圖片，一鍵生成一整套風格統一的表情包',
      features: ['圖片上傳', '尺寸選擇', '補充提示詞', '多圖生成']
    },
    groupPhoto: {
      title: '合照',
      description: '從多張照片生成高品質多人合照',
      features: ['多圖上傳', '多人合成', '可選提示詞'],
      ui: {
        uploadTitle: '上傳合照素材',
        uploadDescription: '最多支援 {max} 張，可預覽與移除',
        promptTitle: '補充提示詞（選填）',
        promptDescription: '可描述場景、氛圍與人物站位',
        promptPlaceholder: '例如：辦公室團隊照、專業打光、自然姿態'
      }
    },
    popArtPortrait: {
      title: '波普藝術肖像',
      description: '將普通照片轉換為充滿活力的波普藝術風格',
      features: ['鮮豔色彩', '藝術風格', '個性化']
    },
    animeStyle: {
      title: '動漫風格轉換',
      description: '將真實照片轉換為精美的動漫風格插畫',
      features: ['動漫效果', '二次元', '插畫風格']
    },
    oilPainting: {
      title: '油畫風格',
      description: '模擬傳統油畫技法，創造經典藝術作品',
      features: ['油畫質感', '藝術風格', '經典美學']
    },
    watercolor: {
      title: '水彩畫風格',
      description: '創造柔和透明的水彩畫藝術效果',
      features: ['水彩效果', '柔和色調', '藝術感']
    },
    sketchStyle: {
      title: '素描風格',
      description: '轉換為精細的鉛筆素描或炭筆畫',
      features: ['素描效果', '線條藝術', '黑白處理']
    },
    cyberpunk: {
      title: '賽博朋克風格',
      description: '創造未來科技感的賽博朋克藝術風格',
      features: ['科技感', '霓虹效果', '未來風格']
    },
    faceSwap: {
      title: 'AI 捏臉',
      description: '上傳一張包含人臉的圖片，即可生成不同風格的頭像',
      features: ['AI 捏臉', '多種風格', '頭像生成']
    },
    professionalPortrait: {
      title: '職業肖像照',
      description: '將照片轉換為專業的商務肖像',
      features: ['商務風格', '專業打光', '企業適用']
    },
    photoRestoration: {
      title: '圖片修復',
      description: '修復老舊、損壞或褪色的照片，去除劃痕、污漬和瑕疵',
      features: ['老照片修復', '去除瑕疵', '色彩恢復']
    },
    imageUpscaler: {
      title: '圖像放大器',
      description: '使用AI技術提升圖像解析度和品質',
      features: ['AI增強', '高解析度', '品質提升']
    },
    imageMatting: {
      title: '智慧摳圖',
      description: '自動移除圖片背景，生成透明背景圖片',
      features: ['自動去背', '高精度識別', '透明背景'],
      ui: {
        uploadTitle: '上傳圖片',
        uploadDescription: '支援 JPG, PNG 格式',
        downloadTitle: '下載結果',
        downloadDescription: '下載透明背景圖片'
      }
    },
    worldView: {
      title: '全球打卡',
      description: '在谷歌地圖選點，獲取當地天氣與位置信息，生成合照',
      features: ['谷歌地圖選點', '實時天氣', '多人合成'],
      ui: {
        uploadTitle: '上傳照片',
        uploadDescription: '支援多圖上傳，可預覽與移除',
        promptTitle: '提示詞',
        promptDescription: '描述場景、服裝、氛圍與細節',
        promptPlaceholder: '例如：清晨海邊，寫實，保留人物服裝與身份，真實光影'
      },
      mapCard: {
        title: '地圖資訊',
        description: '從地圖選擇位置並填充到卡片',
        location: '位置',
        coords: '座標',
        weather: '天氣',
        notSelected: '未選擇',
        loading: '加載中…',
        openMapButton: '選擇地圖位置',
        searchPlaceholder: '搜尋地點',
        confirmButton: '使用此位置',
        selectedPoint: '已選擇：',
        resolving: '解析中…'
      }
    }
  };
